import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000200FindRequest = Partial<{
  shohinCdFrom: string;
  shohinCdTo: string;
  janCdFrom: string;
  janCdTo: string;
  name: string;
  sakaCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  deljogaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000200FindResponse = {
  shohinCd: string;
  shohinNm: string;
  shohinNmr: string;
  shohinKana: string;
  janCd: string;
  sakaNm: string;
  shohindaibun: string;
  shohinchubun: string;
  shohinshobun: string;
  vol: string;
  sakaCd: string;
  shokuchiKbn: string;
  kazeiKbn: string;
  tankaKbn: string;
  whtankaCd: string;
  whgentankaCd: string;
  shireCd: string;
  itfCd: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  urikiriKbn: string;
  zairyoshohinCd: string;
  tashisun: string;
  loss2: string;
  sunpo: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kakoshubetsuCd: string;
  shiyo1: string;
  shiyo2: string;
  shiyo3: string;
  zaikokanriKbn: string;
  zaikohikiateKbn: string;
  minuszaikocheckKbn: string;
  shobunCd1: string;
  shobunCd2: string;
  shobunCd3: string;
  shobunCd4: string;
  shobunCd5: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  sakujoyoteiKbn: string;
  chohyoBunruiCd1: string;
  chohyoBunruiCd2: string;
  chohyoBunruiCd3: string;
  chohyoBunruiCd4: string;
  chohyoBunruiCd5: string;
  chohyoBunruiCd6: string;
  chohyoBunruiCd7: string;
  chohyoBunruiCd8: string;
  chohyoBunruiCd9: string;
  chohyoBunruiCd10: string;
  chohyoBunruiCd11: string;
  chohyoBunruiCd12: string;
  chohyoBunruiCd13: string;
  chohyoBunruiCd14: string;
  chohyoBunruiCd15: string;
  version: string;
};

export const B000200Find = (props: B000200FindRequest) => {
  return RestClient.get<PageableResponse<B000200FindResponse[]>>(
    "b000200/find",
    {
      params: props,
    }
  );
};

export type B000200GetRequest = {
  shohinCd: string;
};

export const B000200Get = (props: B000200GetRequest) => {
  return RestClient.get("b000200/get", {
    params: props,
  });
};

//商品コードで商品名を取得するメソッド
export const B000200ShohinNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("shohinNm", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("shohinNm", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm", "");
    });
};

//セット商品コードで商品名を取得するメソッド
export const B000200SetshohinNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.setshohinCd === "") {
    methods.setValue("shohinNm", data.setshohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.setshohinCd })
    .then((response) => {
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm", "");
    });
};

//商品コードで商品名を取得するメソッド(返却値は商品マスタ.商品名略)
export const B000200ShohinNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("shohinNm2", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("shohinNm2", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm2", "");
    });
};

//商品コードで商品名略を取得するメソッド
export const B000200ShohinNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("shohinNmr", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("shohinNmr", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmr", "");
    });
};

//商品コードで商品名(From)を取得
export const B000200ShohinNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCdFrom === "") {
    methods.setValue("shohinNmFrom", data.shohinCdFrom);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCdFrom })
    .then((response) => {
      methods.setValue("shohinNmFrom", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmFrom", "");
    });
};

//商品コードで商品名(To)を取得
export const B000200ShohinNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCdTo === "") {
    methods.setValue("shohinNmTo", data.shohinCdTo);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCdTo })
    .then((response) => {
      methods.setValue("shohinNmTo", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmTo", "");
    });
};

//shohinNmrShohinCd取得
export const B000200ShohinNmrShohinCd = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("shohinNmrShohinCd", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("shohinNmrShohinCd", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmrShohinCd", "");
    });
};

//商品コード(材料品コード)で商品名を取得するメソッド
export const B000200ZairyoshohinNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.zairyoshohinCd === "") {
    methods.setValue("zairyoshohinNm", data.zairyoshohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.zairyoshohinCd })
    .then((response) => {
      methods.setValue("zairyoshohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("zairyoshohinNm", "");
    });
};

//受注入力用(フロント詳細設計書処理詳細6に該当する)商品コードで商品コード、JANコード、商品名を取得するメソッド
export const B000200Shohin = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("janCd", data.shohinCd);
    methods.setValue("shohinNm", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("janCd", response.data.janCd ?? "");
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm", "");
    });
};

export type B000200GetByJanCdRequest = {
  janCd: string;
};

export const B000200GetByJanCd = (props: B000200GetByJanCdRequest) => {
  return RestClient.get("b000200/get/jancd", {
    params: props,
  });
};

//JANコードで商品名を取得するメソッド(コンポーネント名はshohinNm)
export const B000200ByJanCdShohinNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("shohinNm", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm", "");
    });
};

//JANコードで商品名略を取得するメソッド(コンポーネント名はshohinNmr)
export const B000200ByJanCdShohinNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("shohinNmr", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("shohinNmr", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmr", "");
    });
};

//janshohinNm取得(返却値は商品マスタ.商品名略)
export const B000200JanshohinNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("janshohinNm", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("janshohinNm", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janshohinNm", "");
    });
};

//受注入力用(フロント詳細設計書処理詳細6に該当する)JANコードで商品コード、JANコード、商品名を取得
export const B000200ByJanCdShohin = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("shohinCd", data.shohinCd);
    methods.setValue("shohinNm", data.shohinCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("shohinCd", response.data.shohinCd ?? "");
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm", "");
    });
};

//JanNmFromを取得
export const B000200JanNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdFrom === "") {
    methods.setValue("janNmFrom", data.janCdFrom);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCdFrom })
    .then((response) => {
      methods.setValue("janNmFrom", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janNmFrom", "");
    });
};

//JanNmToを取得
export const B000200JanNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdTo === "") {
    methods.setValue("janNmTo", data.janCdTo);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCdTo })
    .then((response) => {
      methods.setValue("janNmTo", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janNmTo", "");
    });
};

//shohinNmrJanCd取得
export const B000200ShohinNmrJanCd = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("shohinNmrJanCd", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("shohinNmrJanCd", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmrJanCd", "");
    });
};

//商品コードで商品名略を取得して商品名1にセットするメソッド
export const B000200ShohinNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.setValue("shohinNm1", data.shohinCd);
    return;
  }
  await B000200Get({ shohinCd: data.shohinCd })
    .then((response) => {
      methods.setValue("shohinNm1", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm1", "");
    });
};

//JANコードで商品名略を取得して商品名2にセットするメソッド
export const B000200ByJanCdShohinNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("shohinNm2", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("shohinNm2", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNm2", "");
    });
};

//JAN商品名表示(コンポーネントはjanShohinNmr)
export const B000200JanshohinNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("janshohinNmr", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("janshohinNmr", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janshohinNmr", "");
    });
};

//JAN商品名表示(コンポーネントはjanshohinNmr ※L390の処理との違いはコンポーネントの「s」が小文字か大文字か)
export const B000200JanShohinNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCd === "") {
    methods.setValue("janShohinNmr", data.janCd);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCd })
    .then((response) => {
      methods.setValue("janShohinNmr", response.data.shohinNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janShohinNmr", "");
    });
};
// janShohinNmFromを取得
export const B000200JanShohinNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdFrom === "") {
    methods.setValue("janShohinNmFrom", data.janCdFrom);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCdFrom })
    .then((response) => {
      methods.setValue("janShohinNmFrom", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janShohinNmFrom", "");
    });
};

// janShohinNmToを取得
export const B000200JanShohinNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdTo === "") {
    methods.setValue("janShohinNmTo", data.janCdTo);
    return;
  }
  await B000200GetByJanCd({ janCd: data.janCdTo })
    .then((response) => {
      methods.setValue("janShohinNmTo", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janShohinNmTo", "");
    });
};

// セット商品コードで商品名(From)を取得
export const B000200SetShohinNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.setshohinCdFrom === "") {
    methods.setValue("setshohinNmFrom", data.shohinCdFrom);
    return;
  }
  await B000200Get({ shohinCd: data.setshohinCdFrom })
    .then((response) => {
      methods.setValue("setshohinNmFrom", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("setshohinNmFrom", "");
    });
};

// セット商品コードで商品名(To)を取得
export const B000200SetShohinNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.setshohinCdTo === "") {
    methods.setValue("setshohinNmTo", data.shohinCdTo);
    return;
  }
  await B000200Get({ shohinCd: data.setshohinCdTo })
    .then((response) => {
      methods.setValue("setshohinNmTo", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("setshohinNmTo", "");
    });
};
